import { effect, signal } from '@angular/core'
import { FormGroup, Validators } from '@angular/forms'

import { ContractPartner } from '../../shared/models/contract-partner.enum'
import { ContactFormControls } from '../../shared/models/main-form'
import { CustomValidators } from '../../shared/validators/custom-validators'
import { NAME_PATTERN } from '../../shared/validators/validator-pattern'

export function useContractPartnerLogic(formGroup: FormGroup<ContactFormControls>) {
  const contractPartner = signal<ContractPartner | null>(null)

  // Contract partner options for the template
  const contractPartnerOptions = [
    { value: ContractPartner.Company, label: 'Ein Unternehmen' },
    { value: ContractPartner.Person, label: 'Eine natürliche Person' },
  ]

  // Set validators based on contract partner selection
  effect(() => {
    const partner = contractPartner()
    const isCompany = partner === ContractPartner.Company
    const isPerson = partner === ContractPartner.Person

    // Set validators
    formGroup.controls.contractOwnerName.setValidators(
      isCompany ? [Validators.required, Validators.maxLength(100)] : []
    )
    formGroup.controls.firstName.setValidators(
      isPerson ? [Validators.required, Validators.maxLength(50), Validators.pattern(NAME_PATTERN)] : []
    )
    formGroup.controls.lastName.setValidators(
      isPerson ? [Validators.required, Validators.maxLength(100), Validators.pattern(NAME_PATTERN)] : []
    )
    formGroup.controls.registrationNumber.setValidators(isCompany ? [CustomValidators.registrationNumberFormat()] : [])

    // Clear values when switching contract partner type
    formGroup.patchValue({
      contractOwnerName: isCompany ? null : '',
      firstName: isPerson ? null : '',
      lastName: isPerson ? null : '',
      ...(isPerson
        ? {
            registrationNumber: null,
            registrationType: null,
            registrationAuthorityName: null,
          }
        : {}),
    })
    formGroup.controls.registrationNumber.updateValueAndValidity({ emitEvent: false })
  })

  return {
    contractPartnerSignal: contractPartner,
    contractPartnerOptions,
    ContractPartner, // Expose enum for template
  }
}
